import { useLocation } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";

const { createContext, useState, useContext, useEffect, useCallback } = require("react");

export const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
  let location = useLocation();
  let state = location.state;

  // console.log("state", state);

  const [createBtn, setCreateBtn] = useState(false);
  const [addDesignBtn, setAddDesignBtn] = useState(false);

  const [creatBtnName, setCreateBtnName] = useState("");
  const [createBtnOption, setCreateBtnOption] = useState([]);
  const [countCart, setCountCart] = useState(0);
  const [removeIcon, setRemoveIcon] = useState(false);
  const [trashModalOpen, setTrashModalOpen] = useState(false);
  const [isArchive, setIsArchive] = useState(false);
  const [isArchiveBtn, setIsArchiveBtn] = useState(false);
  const [checkCatalogBeforeNavigate, setCheckCatalogBeforeNavigate] = useState(false);
  const [newNameCatalog, setNewNameCatalog] = useState("");

  const [isCollectionEditBtn, setIsCollectionEditBtn] = useState(false);
  const [showCollectionTrashIcon, setShowCollectionTrashIcon] = useState(false);
  const [collectionUpdate, setCollectionUpdate] = useState(false);

  const [openCancelModal, setOpenCancelModal] = useState(false);

  const [editCatagoryBtn, setEditCatagoryBtn] = useState(false);
  const [editCatagoryBtnOption, setEditCatagoryBtnOption] = useState([]);
  const [isEditCatagorySelectValue, setIsEditCatagorySelectValue] = useState(false);
  const [isEditCatagoryData, setIsEditCatagoryData] = useState([]);
  const [openEditCatagoryModal, setOpenEditCatagoryModal] = useState(false);
  const [searchPlaceHolder, setSearchPlaceHolder] = useState("Search");
  const [activeCatalogView, setActiveCatalogView] = useState("mixView");

  //Used For Info Model in set-design:-
  const [isInfoBtn, setIsInfoBtn] = useState(false);
  const [infoModalOpen, setInfoModalOpen] = useState(false);

  const [sortIcon, setSortIcon] = useState(false);
  const [sortOptions, setSortOptions] = useState([]);
  const [sortValue, setSortValue] = useState(null);

  const [setDesings, setSetDesings] = useState([]);
  const [filterChangeCount, setFilterChangeCount] = useState(0);
  const [filterChangeDesignCount, setFilterChangeDesignCount] = useState(0);

  const [displayCount, setDisplayCount] = useState(false);
  // const [sahil , setSahil ] = useState(false);

  const [displaySetIcon, setDisplaySetIcon] = useState(false);

  const [breadCrumbLock, setBreadCrumbLock] = useState(false);

  //Right Side bar
  const [rightSideBar, setRightSideBar] = useState(false);

  // Updates Images
  const [showGifIcon, setShowGifIcon] = useState(false);

  const [searchResultCount, setSearchResultCount] = useState(0);
  const [dynamicfilterCount, setDynamicFilterCount] = useState(true);

  const [searchSuffix, setSearchSuffix] = useState("Designs");

  const [btnChange, setBtnChange] = useState(false);
  const [allAdded, setAllAdded] = useState(false);

  const [totals, setTotals] = useState({ totalClients: 0, totalUsers: 0 });

  const [cartData, setCartData] = useState(() => {
    const stored = sessionStorage.getItem("CartData");
    return stored ? JSON.parse(stored) : [];
  });

  const [updateCatalogProductsData, setUpdateCatalogProductsData] = useState(() => {
    const stored = sessionStorage.getItem("updateProductsData");
    return stored ? JSON.parse(stored) : [];
  });

  const [recentlyRemoved, setRecentlyRemoved] = useState(() => {
    const stored = sessionStorage.getItem("RecentlyRemoved");
    return stored ? JSON.parse(stored) : null;
  });

  // Sync sessionStorage if needed
  useEffect(() => {
    sessionStorage.setItem("CartData", JSON.stringify(cartData));
  }, [cartData]);

  useEffect(() => {
    sessionStorage.setItem("updateProductsData", JSON.stringify(updateCatalogProductsData));
  }, [updateCatalogProductsData]);

  useEffect(() => {
    sessionStorage.setItem("RecentlyRemoved", JSON.stringify(recentlyRemoved));
  }, [recentlyRemoved]);

  // const addToCart = (product) => {

  //   if (!cartData.some((item) => item.styleNumber === product.styleNumber)) {
  //     setCartData((prev) => [...prev, { ...product, isAddedInCart: true }]);
  //   }
  // };
  const addToCart = (product) => {
    const isPlacingOrder = state?.newName === "Create Order";

    const alreadyInCart = cartData.some((item) => item.styleNumber === product.styleNumber);

    if (alreadyInCart && !isPlacingOrder) return;

    let updatedProduct = { ...product, isAddedInCart: true };

    if (isPlacingOrder) {
      const needsUpdate =
        (product.hasOwnProperty("diaQlty") && product.diaQlty !== "VVS-GH") ||
        (product.hasOwnProperty("goldColor") && product.goldColor !== "P") ||
        (product.hasOwnProperty("goldQlty") && product.goldQlty !== "18") ||
        (product.hasOwnProperty("itemSize") && product.itemSize !== null);
      if (needsUpdate) {
        updatedProduct = {
          ...product,
          diaQlty: "VS-GH",
          goldColor: "P",
          goldQlty: "18",
          itemSize: null,
          isAddedInCart: true,
        };
      }

      updatedProduct.cartItemId = uuidv4();
    }

    setCartData((prev) => {
      const newCart = [...prev, updatedProduct];
      return newCart;
    });
  };

  // const addToCart = useCallback((product, isPlacingOrder) => {
  //   setCartData((prev) => {
  //     if (prev.some(item => item.styleNumber === product.styleNumber)) {
  //       return prev;
  //     }

  //     let updatedProduct = { ...product, isAddedInCart: true };

  //     if (isPlacingOrder) {
  //       const needsUpdate =
  //         (product.diaQlty && product.diaQlty !== "VVS-GH") ||
  //         (product.goldColor && product.goldColor !== "P") ||
  //         (product.goldQlty && product.goldQlty !== "18") ||
  //         (product.itemSize !== null);

  //       if (needsUpdate) {
  //         updatedProduct = {
  //           ...product,
  //           diaQlty: "VS-GH",
  //           goldColor: "P",
  //           goldQlty: "18",
  //           itemSize: null,
  //           isAddedInCart: true,
  //         };
  //       }
  //     }

  //     return [...prev, updatedProduct];
  //   });
  // }, []);

  const removeFromCart = (product) => {
    setCartData((prev) => {
      const index = prev.findIndex((item) => item.styleNumber === product.styleNumber);
      if (index === -1) return prev;

      const updated = [...prev];
      updated.splice(index, 1); // remove one item only(due to new + - ui changes )
      return updated;
    });

    setRecentlyRemoved(product);
  };

  const isInCart = (styleNumber) => {
    return cartData.some((item) => item.styleNumber === styleNumber);
  };
  //Order Client Details
  const [clientDetails, setClientDetails] = useState(null);
  const [clientDetailsComp, setClientDetailsComp] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);
  const [expanded, setExpanded] = useState(true);
  const [catalogData, setCatalogData] = useState([]);

  // Date Range Picker
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const storedFilter = JSON.parse(sessionStorage.getItem("AppliedDateFilter") || "{}");

  const [selectedStartDate, setSelectedStartDate] = useState(storedFilter.appliedStartDate ? new Date(storedFilter.appliedStartDate) : new Date()); // temp
  const [selectedEndDate, setSelectedEndDate] = useState(storedFilter.appliedEndDate ? new Date(storedFilter.appliedEndDate) : null);

  const [appliedStartDate, setAppliedStartDate] = useState(storedFilter.appliedStartDate ? new Date(storedFilter.appliedStartDate) : new Date()); // final
  const [appliedEndDate, setAppliedEndDate] = useState(storedFilter.appliedEndDate ? new Date(storedFilter.appliedEndDate) : null);

  // comment State
  const [currentAudioId, setCurrentAudioId] = useState(null);

  const [showProductionImages, setShowProductionImages] = useState(false);

  const [serviceRequestCounts, setServiceRequestCounts] = useState({
    byStatus: {},
    byServiceType: {},
  });

  const [currentStatus, setCurrentStatus] = useState("");
  const [canReOpen, setCanReOpen] = useState(true);

  const [approvalTime, setApprovalTime] = useState(null);
  const [scrollToBottomTrigger, setScrollToBottomTrigger] = useState(false);

  const [showActivityLogo, setShowActivityLogo] = useState(false);
  const [meltingStatus, setMeltingStatus] = useState("");
  const [meltingProducts, setMeltingProducts] = useState([]);

  const [archiveCatalog, setArchiveCatalog] = useState(() => {
    const stored = sessionStorage.getItem("catalogArchive");
    return stored ? JSON.parse(stored) : [];
  });

  const [sectionCounts, setSectionCounts] = useState({});

  const [isLiveStreaming, setIsLiveStreaming] = useState(false);
  
  const [checkedItems, setCheckedItems] = useState(() => {
    return JSON.parse(sessionStorage.getItem("checkedItems")) || [];
  });
  
  const [activateFinalise, setActivateFinalise] = useState(false);

  const [serviceRequestDetail, setServiceRequestDetail] = useState({});

  return (
    <GlobalContext.Provider
      value={{
        trashModalOpen,
        setTrashModalOpen,
        removeIcon,
        setRemoveIcon,
        createBtn,
        setCreateBtn,
        creatBtnName,
        setCreateBtnName,
        createBtnOption,
        setCreateBtnOption,
        countCart,
        setCountCart,
        isArchive,
        setIsArchive,
        isArchiveBtn,
        setIsArchiveBtn,
        checkCatalogBeforeNavigate,
        setCheckCatalogBeforeNavigate,
        newNameCatalog,
        setNewNameCatalog,

        showCollectionTrashIcon,
        setShowCollectionTrashIcon,
        addDesignBtn,
        setAddDesignBtn,

        collectionUpdate,
        setCollectionUpdate,

        openCancelModal,
        setOpenCancelModal,

        editCatagoryBtn,
        setEditCatagoryBtn,
        editCatagoryBtnOption,
        setEditCatagoryBtnOption,
        isEditCatagorySelectValue,
        setIsEditCatagorySelectValue,
        isEditCatagoryData,
        setIsEditCatagoryData,
        openEditCatagoryModal,
        setOpenEditCatagoryModal,
        searchPlaceHolder,
        setSearchPlaceHolder,

        isInfoBtn,
        setIsInfoBtn,
        infoModalOpen,
        setInfoModalOpen,

        sortIcon,
        setSortIcon,
        sortOptions,
        setSortOptions,
        sortValue,
        setSortValue,
        setDesings,
        setSetDesings,

        filterChangeCount,
        setFilterChangeCount,

        filterChangeDesignCount,
        setFilterChangeDesignCount,

        displayCount,
        setDisplayCount,

        showGifIcon,
        setShowGifIcon,

        displaySetIcon,
        setDisplaySetIcon,

        breadCrumbLock,
        setBreadCrumbLock,
        rightSideBar,
        setRightSideBar,

        searchResultCount,
        setSearchResultCount,

        dynamicfilterCount,
        setDynamicFilterCount,

        searchSuffix,
        setSearchSuffix,
        btnChange,
        setBtnChange,
        addToCart,
        removeFromCart,
        isInCart,
        cartData,
        setCartData,
        updateCatalogProductsData,
        setUpdateCatalogProductsData,
        recentlyRemoved,

        clientDetails,
        setClientDetails,
        clientDetailsComp,
        setClientDetailsComp,

        setNotificationCount,
        notificationCount,
        expanded,
        setExpanded,

        allAdded,
        setAllAdded,
        catalogData,
        setCatalogData,
        isCalendarOpen,
        setIsCalendarOpen,

        selectedStartDate,
        setSelectedStartDate,

        selectedEndDate,
        setSelectedEndDate,

        appliedStartDate,
        setAppliedStartDate,

        appliedEndDate,
        setAppliedEndDate,

        totals,
        setTotals,

        currentAudioId,
        setCurrentAudioId,
        showProductionImages,
        setShowProductionImages,
        serviceRequestCounts,
        setServiceRequestCounts,
        currentStatus,
        setCurrentStatus,
        approvalTime,
        setApprovalTime,

        showActivityLogo,
        setShowActivityLogo,

        scrollToBottomTrigger,
        setScrollToBottomTrigger,

        meltingStatus,
        setMeltingStatus,

        archiveCatalog,
        setArchiveCatalog,

        sectionCounts,
        setSectionCounts,

        isLiveStreaming,
        setIsLiveStreaming,

        canReOpen,
        setCanReOpen,

        checkedItems,
        setCheckedItems,

        meltingProducts,
        setMeltingProducts,

        serviceRequestDetail,
        setServiceRequestDetail,
        activateFinalise,
        setActivateFinalise,
        activeCatalogView,
        setActiveCatalogView,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobalContext = () => useContext(GlobalContext);
